const faqs = [
  {
    q: '窝窝影院真的完全免费吗？',
    a: '是的，窝窝影院所有电视剧、综艺、动漫内容均完全免费在线观看，无需注册会员，无需付费解锁，打开就能看。我们通过技术优化降低运营成本，致力于为每一位追剧爱好者提供零门槛的观影体验。',
  },
  {
    q: '播放画质怎么样？会卡顿吗？',
    a: '窝窝影院支持最高 1080P 超清画质播放，并且采用全球 CDN 智能加速技术，根据你的网络环境自动调节最佳码率。正常网络环境下可以做到即点即播、流畅不缓冲，让你享受媲美影院的观影体验。',
  },
  {
    q: '剧集多久更新一次？',
    a: '窝窝影院每日更新 200+ 剧集内容，热门国产剧、韩剧、美剧均与播出平台保持同步更新。我们建立了高效的资源采集与转码系统，确保最新剧集在播出后第一时间上线，让你紧跟追剧大部队的步伐。',
  },
  {
    q: '支持哪些设备观看？',
    a: '窝窝影院完美适配电脑、平板和手机端，你可以在任何设备上通过浏览器直接访问观看。此外，我们支持 DLNA 和 AirPlay 投屏功能，可以一键将正在播放的剧集投射到智能电视上，享受大屏追剧的畅快体验。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-500">你想知道的都在这里</p>
        </div>

        <div className="max-w-3xl mx-auto flex flex-col gap-3">
          {faqs.map((faq) => (
            <div key={faq.q} className="bg-background-100 rounded-xl p-5 md:p-6">
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-2">{faq.q}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}